diy.angular.registerFactory('diyfmuploadqueue', ['$q', function($q) {

    var queues = {};
    
    function UploadQueueItem(itemConfig, addDefer) {
        var 
            xhr,
            uploadDefer,
            finished = false,
            inProgress = false,
            progress,
            config = angular.extend({
                method: 'POST',
                data: null,
                dataParamName: 'data',
                fileParamName: 'file'
            }, itemConfig);
        ;
        
        var getConfig = function() {
            return itemConfig;
        };
        var getSize = function() {
            return config.file.size;
        };
        
        var isInProgress = function() {
            return inProgress;
        };
        
        var isFinished = function() {
            return finished;
        };
        
        var upload = function() {
            /* perform upload */
            inProgress = true;
            uploadDefer = $q.defer();
            
            var prevLoadedBytes = 0;
            
            xhr = new XMLHttpRequest();
            
            /* register progress event */
            xhr.upload.addEventListener("progress", function(e) {
                uploadDefer.notify(e.loaded - prevLoadedBytes);
                progress = e.loaded / e.total;
                // XXX we deliberately lower the progress
                // because between the event when progress = 1 and load event
                // there is a waiting time from the server to respond
                progress = progress * .75;
                addDefer.notify(progress);
                prevLoadedBytes = e.loaded;
            });
            /* register successful event */
            xhr.addEventListener("load", function(e) {
                inProgress = false;
                finished = true;
                // if we received a success http return code
                if (e.target.status >= 200 && e.target.status < 300) {
                    // XXX force a full progress here
                    addDefer.notify(1);
                    addDefer.resolve(this.responseText);
                    // we need to put uploadDefer later than addDefer, 
                    // otherwise that when all in the queue are uploaded
                    // upload complete will trigger even if addition is not
                    // annouced yet and resource may not be created properly
                    uploadDefer.resolve();
                } else { // if we received an error http code
                    addDefer.reject({code: e.target.status, message: e.target.responseText});
                    uploadDefer.reject({code: e.target.status});
                }
            });
            /* register error event */
            xhr.addEventListener("error", function(e) {
                inProgress = false;
                finished = true;
                uploadDefer.reject();
                addDefer.reject();
            });
            
            xhr.addEventListener("abort", function(e) {
                inProgress = false;
                finished = true;
                uploadDefer.reject('cancel');
                addDefer.reject('cancel');
            });
            
            var formData = new FormData();
            
            if (config.data) {
                formData.append(config.dataParamName, angular.toJson(config.data));
            }
            formData.append(config.fileParamName, config.file);
            
            xhr.open(config.method, config.url, true);
            xhr.setRequestHeader('X-DiyCSRFToken', jimdoData.cstok);
            xhr.send(formData);
            
            /* send an initial progress event with 0 */
            addDefer.notify(0);
            
            return uploadDefer.promise;
        };
        
        var cancel = function() {
            if (isInProgress()) {
                // XXX Canceling an inprogress request 
                // is not reliable, because server still will process
                // the request and then we will be inconsistent on client side
                //xhr && xhr.abort();
            } else if (!isFinished()) {
                addDefer.reject('cancel');
            }
        };
        
        return angular.extend(this, {
            getConfig: getConfig,
            getSize: getSize,
            isInProgress: isInProgress,
            isFinished: isFinished,
            upload: upload,
            cancel: cancel
        });
    };
    
    function UploadQueue() {
        // TODO make this configurable
        // If this is bigger than 1, we cannot guarantee
        // that on the server files will be processed in the
        // same order, so for now we should keep it at 1
        var MAX_PARALLEL = 1;
        var
            items,
            totalUploaded,
            totalSize,
            queueDefer
        ;
            
        var initQueue = function() {
            items = [];
            totalUploaded = 0;
            totalSize = 0;
            // we should renew the defer, because
            // after resolve() or reject() it will not notify anymore
            queueDefer = $q.defer();
        };
        initQueue();
        
        var add = function(itemConfig) {
            
            var addDefer = $q.defer();
            // validation
            if (!(itemConfig.file instanceof File)) {
                throw 'No file defined';
            }
            
            var item = new UploadQueueItem(itemConfig, addDefer);
            items.push(item);
            totalSize += item.getSize();
            
            return addDefer.promise;
        };
        
        var remove = function(itemConfig) {
            var item;
            for (var i = 0, l = items.length; i < l; i++) {
                item = items[i];
                if (itemConfig === item.getConfig()) {
                    if (item.isInProgress()) {
                        totalUploaded -= item.getUploaded();
                        item.cancel();
                    }
                    totalSize -= item.getSize();
                    queueDefer.notify(totalUploaded / totalSize);
                    item = null;
                    items.splice(i, 1);
                }
            }
        };
        // Cancel all not finished  
        var cancel = function() {
            for (var i = 0, l = items.length; i < l; i++) {
                if (!items[i].isFinished()) {
                    items[i].cancel();
                }
            }
            queueDefer.reject('cancel');
            initQueue();
        };
        
        var start = function() {
            queueDefer.notify(totalUploaded / totalSize); // initial notification with 0
            startNext();
        };
        
        var startNext = function() {
            var item, inProgressCount = getInProgressCount(), finishedCount = 0;
            if (inProgressCount < MAX_PARALLEL) {
                for (var i = 0; i < items.length; i++) {
                    item = items[i];
                    if (item.isFinished()) {
                        finishedCount++;
                    } else {
                        if (!item.isInProgress()) {
                            item.upload().then(function(){
                                startNext();
                            }, function() {
                                startNext();
                            }, function(delta) {
                                var progress;
                                totalUploaded += delta;
                                progress = totalUploaded / totalSize;
                                // XXX we deliberately lower the progress
                                // because between the event when progress = 1 and load event
                                // there is a waiting time from the server to respond
                                progress = progress * .85;
                                queueDefer.notify(progress);
                            });
                            inProgressCount++;
                            if (inProgressCount === MAX_PARALLEL) {
                                break;
                            }
                        }
                    }
                }
            }
            if (finishedCount === items.length) {
                // XXX force a full progress notification
                queueDefer.notify(1);
                queueDefer.resolve(items);
                initQueue();
            }

            return true;
        };

        var getInProgressCount = function() {
            var howMany = 0;
            for (var i = 0; i < items.length; i++) {
                if (items[i].isInProgress()) {
                    howMany++;
                }
            }
            return howMany;
        };
        
        var getProgress = function() {
            return totalUploaded / totalSize;
        }
        
        var getPromise = function() {
            return queueDefer.promise;
        }

        return {
            add: add,
            remove: remove,
            start: start,
            cancel: cancel,
            getPromise: getPromise,
            getProgress: getProgress,
            getInProgressCount: getInProgressCount
        }
    };

    
    return {
        get: function(queueName) {
            if (!queues[queueName]) {
                queues[queueName] = new UploadQueue();
            }
            return queues[queueName];
        }
    };

}]);








/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/services/diyfmuploadqueue.js
 ** module id = 938
 ** module chunks = 0
 **/